export { default } from "./TeacherToolsCollapseHeader";
